import { render, staticRenderFns } from "./ComponentUserFormAlarmContent.vue?vue&type=template&id=6b588854&scoped=true&"
import script from "./ComponentUserFormAlarmContent.vue?vue&type=script&lang=ts&"
export * from "./ComponentUserFormAlarmContent.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentUserFormAlarmContent.vue?vue&type=style&index=0&id=6b588854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b588854",
  null
  
)

export default component.exports